import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { textSizes } from 'theme/media'
import { IStyles } from '../../../theme'

const deviceSettingsExhibitionMode: IStyles = {
    title: {
        fontSize: textSizes.normal,
    },
    description: {
        fontSize: textSizes.mini,
        ...grid.mt_mini,
    },
    switchWrapper: {
        display: 'flex',
    },
    switchCaption: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 14,

        span: {
            marginRight: 6,
        },
    },
}

addStyles(deviceSettingsExhibitionMode)
export default deviceSettingsExhibitionMode
